import { LocalTokenHelper } from "./LocalTokenHelper";

export interface ISendOptions {
    method: string;
    body: string | null;
    authenticated: boolean;
}

// The application ID for the website to identify itself with the server.
const WEBSITE_APPLICATION_ID = "98b8fc18-604a-4a5c-88a2-a901f941151d";

export class RestHelper {
    static RootUrl: string = "https://api.rhythmhorizon.com";
    //static RootUrl: string = "https://rhplatformapp-staging.azurewebsites.net";
    //static RootUrl: string = "https://localhost:44300";

    // Sends a GET REST request to the server.
    static get(url: string, authenticated:boolean = true) : Promise<Response> {
        return RestHelper.send(url, { method: "GET", body: null, authenticated: authenticated });
    }

    // Sends a POST REST request to the server.
    static post(url: string, body: string, authenticated:boolean = true) : Promise<Response> {
        return RestHelper.send(url, { method: "POST", body: body, authenticated: authenticated });
    }

    // Refreshes the user user login and refresh tokens on the server and stores them in the RestHelper cache.
    public static async refreshTokens() {
        let refreshToken = LocalTokenHelper.getRefreshToken();
        let body = `grant_type=refresh_token&refresh_token=${refreshToken}`
        let response: Response = await RestHelper.post(`${RestHelper.RootUrl}/sdk/token`, body, false);

        if (response.ok) {
            let json:any = await response.json();

            // Save the tokens in storage.
            LocalTokenHelper.saveLoginTokens(json.access_token, json.refresh_token);

            return true;
        }
        else {
            return false;
        }
    }

    // Sends a REST request to the server.
    private static async send(url: string, options: ISendOptions) : Promise<Response> {
        let headers: any = {}
        headers.LamaApplicationId = WEBSITE_APPLICATION_ID;
        headers.Accept = 'application/json'

        if (options.authenticated) {
            let loginToken = LocalTokenHelper.getLoginToken();
            headers.Authorization = `Bearer ${loginToken}`;
        }

        let response : Response = await fetch(
            url,
            {
                method: options.method,
                body: options.body,
                headers: headers,
            }
        );

        return response;
    }
};